export interface ScientificAnalysisRenameModalState {
    templateId: number
    oldName: string
    name: string
}
export const initialScientificAnalysisRenameModalState =
    (): ScientificAnalysisRenameModalState => ({
        templateId: -1,
        oldName: '',
        name: ''
    })
